export default "__VITE_ASSET__CyehSjsY__"